import styled from 'styled-components'

interface IWithCurrencyConversionTooltipStyledProps {}

export const WithCurrencyConversionTooltipStyled = styled.div<IWithCurrencyConversionTooltipStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  padding: 1em;
`
